import { Col, Container, Row } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import React, { useEffect, useState } from "react";
import userService from "../../service/UserService";
import { ViewUsers } from '../users/viewUsers';

export const Home = () => {
    const [stats, setStats] = useState([])
    
    useEffect(() => {
      fetchStats()
    }, [])
  
    const fetchStats = async () => {
      const response = await userService.stats() ;
  
      if(response.status==200) {
        console.log(response)
        setStats(response.data.data.dashboardData)
      } 
    }

    return (
        <>
            <div className="dashboard-main-area">
                <Container fluid>
                    <div className="dashboard-area-heading management-heading">
                        <div className='top-head-area'>
                            <h5>Dashboard</h5>
                        </div>
                        <Row>
                            <Col md={3}>
                                <div className="dashboard-boxes">
                                    <p>Total Users</p>
                                    <div className='dashboard-box-bottom'>
                                        <h3>{ stats.userCount || 0 }</h3>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="dashboard-boxes business-user">
                                    <p>Total Validators</p>
                                    <div className='dashboard-box-bottom'>
                                        <h3>{ stats.validatorCount || 0}</h3>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="dashboard-boxes individual-referral">
                                    <p>Total Orders</p>
                                    <div className='dashboard-box-bottom'>
                                        <h3>{ stats.totalOrders || 0}</h3>
                                    </div>
                                </div>
                            </Col>
                            <Col md={3}>
                                <div className="dashboard-boxes individual-referral-end">
                                    <p>Total Earnings</p>
                                    <div className='dashboard-box-bottom'>
                                    <h3>{ stats.totalEarnings != null ? stats.totalEarnings.toFixed(2) : '0.00' }</h3>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        {/* pricong graph here */}

                    </div>
                </Container>
            </div>
        </>
    );
};
